import { InformationCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { toMoney } from "shared/utils";
import { formatDate } from "views/applications-id-report/utils";
import { Override } from "../types";
import { Show } from "shared/components";

export const SummaryUpdated = ({
  changes,
  original,
  className
}: {
  className?: string;
  changes?: Override;
  original?: {
    gross?: number | null;
    net?: number | null;
  };
}) => {
  if (!changes || !original) return null;

  const isGrossChanged = changes.gross_monthly_income !== original.gross,
    isNetChanged = changes.net_monthly_income !== original.net;

  return (
    <div className={className}>
      <Show if={isGrossChanged}>
        <div className="flex gap-4 items-center border-t border-alpha-100 pt-6 mt-6">
          <HugeiconsIcon
            icon={InformationCircleIcon}
            size={20}
            className="text-content-200"
          />
          <div className="text-sm text-content-400 space-y-2">
            <h2 className="font-medium">
              Gross monthly income was edited by{" "}
              <span className="text-content-1000">{changes.author.name}</span>{" "}
              on{" "}
              <span className="text-content-1000">
                {formatDate(changes.updated_at, true)}
              </span>
            </h2>
            <p>
              Original value: <span>{toMoney(original.gross || 0)}</span>
            </p>
          </div>
        </div>
      </Show>
      <Show if={isNetChanged}>
        <div className="flex gap-4 items-center border-t border-alpha-100 pt-6 mt-6">
          <HugeiconsIcon
            icon={InformationCircleIcon}
            size={20}
            className="text-content-200"
          />
          <div className="text-sm text-content-400 space-y-2">
            <h2 className="font-medium">
              Net monthly income was edited by{" "}
              <span className="text-content-1000">{changes.author.name}</span>{" "}
              on{" "}
              <span className="text-content-1000">
                {formatDate(changes.updated_at, true)}
              </span>
            </h2>
            <p>Original value: {toMoney(original.net || 0)}</p>
          </div>
        </div>
      </Show>
    </div>
  );
};
